import { apiRequest, getSluiceUrl } from "../../../apiHelper/apiRequest";
import { serialize } from "../../../helpers/helpers";


const list = async (params) => {
	return apiRequest(
        "/school-of-drivers/types/list?" + serialize(params),
        {
            method: "GET"
        },
        'ptp_client'
    );
}


const add = async ( params ) => {
    let add_response = await apiRequest(
                                "/school-of-drivers/types/add",
                                {
                                    method: "POST",
                                    body: params
                                },
                                'ptp_client'
                            );
    if ( typeof(add_response.id) !== 'undefined' && add_response.id )
        return add_response.id;
    else
        return 0;
}


const update = async ( params ) => {
    let add_response = await apiRequest(
                                "/school-of-drivers/types/update",
                                {
                                    method: "PUT",
                                    body: params
                                },
                                'ptp_client'
                            );
    if ( typeof(add_response.id) !== 'undefined' && add_response.id )
        return add_response.id;
    else
        return 0;
}


const remove = async ( id = 0 ) => {
    let remove_response = await apiRequest(
                                "/school-of-drivers/types/delete/" + id,
                                {
                                    method: "DELETE"
                                },
                                'ptp_client'
                            );
    if ( typeof(remove_response.id) !== 'undefined' && remove_response.id )
        return remove_response.id;
    else
        return 0;
}


const getImageUrl = ( category_image = '' ) => {
    if ( String(category_image).trim() === '' || category_image.indexOf('http') === 0 )
        return category_image;
    return getSluiceUrl('ptp_client') + "/school-of-drivers/files/" + category_image;
}


const DriversSchoolCategories = {
    list,
    add,
    update,
    remove,
    getImageUrl
};
export default DriversSchoolCategories;